import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Argentina - QTap';
render(<App data-id="element-372" />, document.getElementById('root'));